import script from "./TextareaInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TextareaInput.vue?vue&type=script&setup=true&lang=js"

import "./TextareaInput.vue?vue&type=style&index=0&id=3107eefc&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3107eefc"]])

export default __exports__